import styles from "./login.module.scss"
import ForgotPasswordContainer from "../authentication/forgotPassword/forgotPasswordContainer";
import AuthenticationLayout from "../authentication/authenticationLayout";

export default function ForgotPassword() {

    return <AuthenticationLayout title="Zapomniałem hasła">
        <ForgotPasswordContainer/>
    </AuthenticationLayout>
}